export class CampaignTabs {
    static readonly KeyStats: number = 1;
    static readonly DeliveryStats: number = 2;
    static readonly InteractionStats: number = 3;
}


// WEBPACK FOOTER //
// ./src/app/campaigns/campaign.enum.ts